import { useEffect, useState } from 'react';
import { getEnv } from '../environment/resolve';

// Which backend is this build talking to? Backend selection is host-driven
// (see environment/resolve.js), so this is derived from the serving hostname.
// Nothing renders on production.
const LABELS = {
  development: {
    text: 'DEV',
    color: '#1677ff'
  },
  stage: {
    text: 'STAGE',
    color: '#d46b08'
  }
};
const EnvBadge = () => {
  // Resolve on the client only: the static export must not bake a badge
  // (that would flash on prod before hydration and pollute the SSG output).
  const [env, setEnv] = useState(null);
  useEffect(() => {
    setEnv(getEnv());
  }, []);
  const label = env && LABELS[env.deployment];
  if (!label) return null; // production or unknown → nothing

  const host = (env.appHost || '').replace(/^https?:\/\//, '');
  const release = typeof window !== 'undefined' ? window.__BUILD_INFO__?.release : undefined;
  return <div className="no-print" role="status" aria-label={`${label.text} backend: ${host}`} title={release ? `Build: ${release}` : undefined} style={{
    position: 'fixed',
    bottom: 12,
    right: 12,
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    borderRadius: 6,
    background: label.color,
    color: '#fff',
    font: '600 12px/1 system-ui, -apple-system, sans-serif',
    letterSpacing: 0.4,
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
    pointerEvents: 'none',
    userSelect: 'none'
  }} data-sentry-component="EnvBadge" data-sentry-source-file="EnvBadge.jsx">
      <span style={{
      width: 8,
      height: 8,
      borderRadius: '50%',
      background: '#fff',
      opacity: 0.9
    }} />
      {label.text} backend · {host}
    </div>;
};
export default EnvBadge;